import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-setion',
  templateUrl: './contact-setion.component.html',
  styleUrls: ['./contact-setion.component.css']
})
export class ContactSetionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
